export default {
  DRAG_ITEM: '@WS_GALLERY/DRAG_ITEM',
  AFTER: 'after',
  BEFORE: 'before',
  DRAGGING_CLASS: 'ws-gallery-item-dragging',
};
